import './Select.css';

import { cn } from '../../utils/bem';

export const COMPONENT_NAME = 'Select' as const;
export const cnSelect = cn(COMPONENT_NAME);
